"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _SttBox = _interopRequireDefault(require("../SttLayout/SttBox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      border: '1px solid rgba(224, 224, 224, 1)',
      borderRadius: '4px'
    }
  };
});
function SttTable(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
    className: [classes.root, props.classesSttBox].filter(Boolean).join(' ')
  }, /*#__PURE__*/_react["default"].createElement(_Table["default"], props));
}
var _default = SttTable;
exports["default"] = _default;